"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateInvoiceData = exports.toggleNewsletterSubscription = exports.deleteAccount = exports.changeLanguageSuccess = exports.changeLanguage = exports.deleteAddress = exports.editAddress = exports.postAddress = exports.deleteCreditCard = exports.changePassword = exports.cancelOrder = exports.fetchOrdersSuccess = exports.fetchOrders = exports.editPersonalData = exports.fetchAccountSuccess = exports.fetchAccount = exports.UPDATE_INVOICE_DATA = exports.CHANGE_LANGUAGE_SUCCESS = exports.CHANGE_LANGUAGE = exports.DELETE_ACCOUNT = exports.DELETE_ADDRESS = exports.EDIT_ADDRESS = exports.POST_ADDRESS = exports.DELETE_CREDIT_CARD_SUCCESS = exports.DELETE_CREDIT_CARD = exports.SAVE_ADDRESS_SUCCESS = exports.CANCEL_ORDER = exports.FETCH_ORDERS_SUCCESS = exports.FETCH_ORDERS = exports.FETCH_ACCOUNT_FAIL = exports.FETCH_ACCOUNT_SUCCESS = exports.EDIT_PERSONAL_DATA = exports.FETCH_ACCOUNT = exports.CHANGE_PASSWORD = exports.TOGGLE_NEWSLETTER_SUBSCRIPTION = void 0;

var _api = require("@modules/api");

var _snackbar = require("@modules/snackbar");

var _auth = require("@modules/auth");

var _state = require("./state");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ROOT = '@@account';
var TOGGLE_NEWSLETTER_SUBSCRIPTION = "".concat(ROOT, "/TOGGLE_NEWSLETTER_SUBSCRIPTION");
exports.TOGGLE_NEWSLETTER_SUBSCRIPTION = TOGGLE_NEWSLETTER_SUBSCRIPTION;
var CHANGE_PASSWORD = "".concat(ROOT, "/CHANGE_PASSWORD");
exports.CHANGE_PASSWORD = CHANGE_PASSWORD;
var FETCH_ACCOUNT = "".concat(ROOT, "/FETCH_ACCOUNT");
exports.FETCH_ACCOUNT = FETCH_ACCOUNT;
var EDIT_PERSONAL_DATA = "".concat(ROOT, "/EDIT_PERSONAL_DATA");
exports.EDIT_PERSONAL_DATA = EDIT_PERSONAL_DATA;
var FETCH_ACCOUNT_SUCCESS = "".concat(ROOT, "/FETCH_ACCOUNT_SUCCESS");
exports.FETCH_ACCOUNT_SUCCESS = FETCH_ACCOUNT_SUCCESS;
var FETCH_ACCOUNT_FAIL = "".concat(ROOT, "/FETCH_ACCOUNT_FAIL");
exports.FETCH_ACCOUNT_FAIL = FETCH_ACCOUNT_FAIL;
var FETCH_ORDERS = "".concat(ROOT, "/FETCH_ORDERS");
exports.FETCH_ORDERS = FETCH_ORDERS;
var FETCH_ORDERS_SUCCESS = "".concat(ROOT, "/FETCH_ORDERS_SUCCESS");
exports.FETCH_ORDERS_SUCCESS = FETCH_ORDERS_SUCCESS;
var CANCEL_ORDER = "".concat(ROOT, "/CANCEL_ORDER");
exports.CANCEL_ORDER = CANCEL_ORDER;
var SAVE_ADDRESS_SUCCESS = "".concat(ROOT, "/SAVE_ADDRESS_SUCCESS");
exports.SAVE_ADDRESS_SUCCESS = SAVE_ADDRESS_SUCCESS;
var DELETE_CREDIT_CARD = "".concat(ROOT, "/DELETE_CREDIT_CARD");
exports.DELETE_CREDIT_CARD = DELETE_CREDIT_CARD;
var DELETE_CREDIT_CARD_SUCCESS = "".concat(ROOT, "/DELETE_CREDIT_CARD_SUCCESS");
exports.DELETE_CREDIT_CARD_SUCCESS = DELETE_CREDIT_CARD_SUCCESS;
var POST_ADDRESS = "".concat(ROOT, "/POST_ADDRESS");
exports.POST_ADDRESS = POST_ADDRESS;
var EDIT_ADDRESS = "".concat(ROOT, "/EDIT_ADDRESS");
exports.EDIT_ADDRESS = EDIT_ADDRESS;
var DELETE_ADDRESS = "".concat(ROOT, "/DELETE_ADDRESS");
exports.DELETE_ADDRESS = DELETE_ADDRESS;
var DELETE_ACCOUNT = "".concat(ROOT, "/DELETE_ACCOUNT");
exports.DELETE_ACCOUNT = DELETE_ACCOUNT;
var CHANGE_LANGUAGE = "".concat(ROOT, "/CHANGE_LANGUAGE");
exports.CHANGE_LANGUAGE = CHANGE_LANGUAGE;
var CHANGE_LANGUAGE_SUCCESS = "".concat(ROOT, "/CHANGE_LANGUAGE_SUCCESS");
exports.CHANGE_LANGUAGE_SUCCESS = CHANGE_LANGUAGE_SUCCESS;
var UPDATE_INVOICE_DATA = "".concat(ROOT, "/UPDATE_INVOICE_DATA");
exports.UPDATE_INVOICE_DATA = UPDATE_INVOICE_DATA;

var fetchAccount = function fetchAccount(customerToken) {
  var _next;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_ACCOUNT,
    route: "/accounts?customer_token=".concat(customerToken),
    next: (_next = {}, _defineProperty(_next, _api.apiActions.CALL_API_SUCCESS, fetchAccountSuccess), _defineProperty(_next, _api.apiActions.CALL_API_FAIL, function (_ref) {
      var error = _ref.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next),
    schema: _state.transformAccount
  };
};

exports.fetchAccount = fetchAccount;

var fetchAccountSuccess = function fetchAccountSuccess(account) {
  return {
    type: FETCH_ACCOUNT_SUCCESS,
    account: account
  };
};

exports.fetchAccountSuccess = fetchAccountSuccess;

var editPersonalData = function editPersonalData(customerToken) {
  var _next2;

  var personalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: _api.apiActions.CALL_API,
    call: EDIT_PERSONAL_DATA,
    route: "/accounts?customer_token=".concat(customerToken),
    next: (_next2 = {}, _defineProperty(_next2, _api.apiActions.CALL_API_SUCCESS, fetchAccount), _defineProperty(_next2, _api.apiActions.CALL_API_FAIL, function (_ref2) {
      var error = _ref2.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next2),
    params: (0, _api.apiMakeRequestParams)({
      first_name: personalData.firstName,
      last_name: personalData.lastName,
      email: personalData.email,
      postal_code: personalData.postalcode,
      sex: personalData.sex
    }, {
      method: 'PUT'
    })
  };
};

exports.editPersonalData = editPersonalData;

var fetchOrders = function fetchOrders(customerToken) {
  var _next3;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_ORDERS,
    route: "/orders/last-orders?customer_token=".concat(customerToken),
    schema: _state.transformOrders,
    next: (_next3 = {}, _defineProperty(_next3, _api.apiActions.CALL_API_SUCCESS, fetchOrdersSuccess), _defineProperty(_next3, _api.apiActions.CALL_API_FAIL, function (_ref3) {
      var error = _ref3.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next3)
  };
};

exports.fetchOrders = fetchOrders;

var fetchOrdersSuccess = function fetchOrdersSuccess(orders) {
  return {
    type: FETCH_ORDERS_SUCCESS,
    orders: orders
  };
};

exports.fetchOrdersSuccess = fetchOrdersSuccess;

var cancelOrder = function cancelOrder(orderID) {
  return {
    type: _api.apiActions.CALL_API,
    call: CANCEL_ORDER,
    route: "/orders/".concat(orderID, "/cancel"),
    next: _defineProperty({}, _api.apiActions.CALL_API_FAIL, function (_ref4) {
      var error = _ref4.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }),
    params: (0, _api.apiMakeRequestParams)({
      orderId: orderID
    })
  };
};

exports.cancelOrder = cancelOrder;

var changePassword = function changePassword(customerToken) {
  var _next5;

  var passwords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = arguments.length > 2 ? arguments[2] : undefined;
  return {
    type: _api.apiActions.CALL_API,
    call: CHANGE_PASSWORD,
    route: "/accounts/change-password?customer_token=".concat(customerToken),
    params: (0, _api.apiMakeRequestParams)({
      old_password: passwords.oldPassword,
      new_password: passwords.newPassword,
      new_password_repeat: passwords.newPasswordRepeat
    }),
    next: (_next5 = {}, _defineProperty(_next5, _api.apiActions.CALL_API_SUCCESS, _snackbar.snackbarActions.show.bind(null, {
      message: message
    })), _defineProperty(_next5, _api.apiActions.CALL_API_FAIL, function (_ref5) {
      var error = _ref5.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next5)
  };
};

exports.changePassword = changePassword;

var deleteCreditCard = function deleteCreditCard(card) {
  var _next6;

  return {
    type: _api.apiActions.CALL_API,
    call: DELETE_CREDIT_CARD,
    route: "/accounts/credit-cards",
    next: (_next6 = {}, _defineProperty(_next6, _api.apiActions.CALL_API_SUCCESS, fetchAccount), _defineProperty(_next6, _api.apiActions.CALL_API_FAIL, function (_ref6) {
      var error = _ref6.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next6),
    params: (0, _api.apiMakeRequestParams)({
      exp_month: card.expirationMonth,
      exp_year: card.expirationYear,
      number: card.number,
      type: card.type
    }, {
      method: 'DELETE'
    })
  };
};

exports.deleteCreditCard = deleteCreditCard;

var postAddress = function postAddress(address) {
  var _next7;

  return {
    type: _api.apiActions.CALL_API,
    call: POST_ADDRESS,
    route: "/accounts/addresses",
    next: (_next7 = {}, _defineProperty(_next7, _api.apiActions.CALL_API_SUCCESS, fetchAccount), _defineProperty(_next7, _api.apiActions.CALL_API_FAIL, function (_ref7) {
      var error = _ref7.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next7),
    params: (0, _api.apiMakeRequestParams)({
      address_id: address.id,
      alias: address.alias,
      city: address.city,
      company: address.company,
      details: address.details,
      invoice_first_surname: address.invoiceFirstSurname,
      invoice_name: address.invoiceName,
      invoice_person_type: address.invoicePersonType,
      invoice_second_surname: address.invoiceSecondSurname,
      invoice_email: address.invoiceEmail,
      lift: address.lift,
      name: address.name,
      nif: address.nif,
      number: address.number,
      phone: address.phone,
      postal_code: address.postalCode,
      street: address.street
    })
  };
};

exports.postAddress = postAddress;

var editAddress = function editAddress(addressID) {
  var _next8;

  var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: _api.apiActions.CALL_API,
    call: EDIT_ADDRESS,
    route: "/accounts/addresses/".concat(addressID),
    next: (_next8 = {}, _defineProperty(_next8, _api.apiActions.CALL_API_SUCCESS, fetchAccount), _defineProperty(_next8, _api.apiActions.CALL_API_FAIL, function (_ref8) {
      var error = _ref8.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next8),
    params: (0, _api.apiMakeRequestParams)({
      address_id: addressID,
      alias: address.alias,
      city: address.city,
      company: address.company,
      details: address.details,
      invoice_first_surname: address.invoiceFirstSurname,
      invoice_name: address.invoiceName,
      invoice_person_type: address.invoicePersonType,
      invoice_second_surname: address.invoiceSecondSurname,
      invoice_email: address.invoiceEmail,
      lift: address.lift,
      name: address.name,
      nif: address.nif,
      number: address.number,
      phone: address.phone,
      postal_code: address.postalCode,
      street: address.street
    }, {
      method: 'PUT'
    })
  };
};

exports.editAddress = editAddress;

var deleteAddress = function deleteAddress(addressID) {
  var _next9;

  return {
    type: _api.apiActions.CALL_API,
    call: DELETE_ADDRESS,
    route: "/accounts/addresses",
    next: (_next9 = {}, _defineProperty(_next9, _api.apiActions.CALL_API_SUCCESS, fetchAccount), _defineProperty(_next9, _api.apiActions.CALL_API_FAIL, function (_ref9) {
      var error = _ref9.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next9),
    params: (0, _api.apiMakeRequestParams)({
      address_id: addressID
    }, {
      method: 'DELETE'
    })
  };
};

exports.deleteAddress = deleteAddress;

var changeLanguage = function changeLanguage(language, isAuthenticated) {
  var _next10;

  if (!isAuthenticated) return changeLanguageSuccess([], language);
  return {
    type: _api.apiActions.CALL_API,
    call: CHANGE_LANGUAGE,
    route: '/accounts',
    next: (_next10 = {}, _defineProperty(_next10, _api.apiActions.CALL_API_SUCCESS, changeLanguageSuccess), _defineProperty(_next10, _api.apiActions.CALL_API_FAIL, function (_ref10) {
      var error = _ref10.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next10),
    params: (0, _api.apiMakeRequestParams)({
      language: language
    }, {
      method: 'PATCH'
    }),
    nextArgs: [language]
  };
};

exports.changeLanguage = changeLanguage;

var changeLanguageSuccess = function changeLanguageSuccess(payload, language) {
  return {
    type: CHANGE_LANGUAGE_SUCCESS,
    language: language
  };
};

exports.changeLanguageSuccess = changeLanguageSuccess;

var deleteAccount = function deleteAccount() {
  var _next11;

  return {
    type: _api.apiActions.CALL_API,
    call: DELETE_ACCOUNT,
    route: "/accounts/cancel",
    params: (0, _api.apiMakeRequestParams)({}, {
      method: 'POST'
    }),
    next: (_next11 = {}, _defineProperty(_next11, _api.apiActions.CALL_API_SUCCESS, _auth.authActions.purgeAll), _defineProperty(_next11, _api.apiActions.CALL_API_FAIL, function (_ref11) {
      var error = _ref11.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next11)
  };
};

exports.deleteAccount = deleteAccount;

var toggleNewsletterSubscription = function toggleNewsletterSubscription(customerToken, isActive) {
  var _next12;

  return {
    type: _api.apiActions.CALL_API,
    call: TOGGLE_NEWSLETTER_SUBSCRIPTION,
    route: "/accounts/newsletter?customer_token=".concat(customerToken),
    params: (0, _api.apiMakeRequestParams)({}, {
      method: isActive ? 'DELETE' : 'POST'
    }),
    next: (_next12 = {}, _defineProperty(_next12, _api.apiActions.CALL_API_SUCCESS, fetchAccount), _defineProperty(_next12, _api.apiActions.CALL_API_FAIL, function (_ref12) {
      var error = _ref12.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next12)
  };
};

exports.toggleNewsletterSubscription = toggleNewsletterSubscription;

var updateInvoiceData = function updateInvoiceData(addressID) {
  var _next13;

  var invoiceAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: _api.apiActions.CALL_API,
    call: UPDATE_INVOICE_DATA,
    route: "/accounts/addresses/{addressId}/update-invoice-data",
    next: (_next13 = {}, _defineProperty(_next13, _api.apiActions.CALL_API_SUCCESS, fetchAccount), _defineProperty(_next13, _api.apiActions.CALL_API_FAIL, function (_ref13) {
      var error = _ref13.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next13),
    params: (0, _api.apiMakeRequestParams)({
      'address_id': addressID,
      'invoice_person_type': invoiceAddress.invoicePersonType,
      'nif': invoiceAddress.nif,
      'company': invoiceAddress.company,
      'invoice_name': invoiceAddress.invoiceName,
      'invoice_first_surname': invoiceAddress.invoiceFirstSurname,
      'invoice_second_surname': invoiceAddress.invoiceSecondSurname,
      'invoice_email': invoiceAddress.invoiceEmail
    }, {
      method: 'PUT'
    })
  };
};

exports.updateInvoiceData = updateInvoiceData;